<template>
  <div>
    <xolas-table
    table-ref="rentalduetable"

    :url="'/report/property/due/' + rowData.id"
    :fields="fields"

    title="Tenancy Due"
    icon="fa fa-asterisk"

    hide-org-badge
    :show-search="false"

     />

  </div>

</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import XolasTable from '@/components/atoms/tables/XolasTable'

export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    XolasTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },


  data () {
    return {
      // Per-column min-widths in the legacy vuetable's content ratios so el-table
      // flexes them to fill (Site Id wide enough not to wrap) instead of spreading
      // every column equally. Sum stays under the table width — no h-scroll (XOL-231).
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id',
          minWidth: '45'
        },
        {
          name: 'site.siteId',
          title: 'Site Id',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          visible: !this.siteId,
          minWidth: '145'
        },
        {
          name: 'status',
          title: 'Status',
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary',
          minWidth: '75'
        },
        {
          name: 'landowner',
          title: 'Landlord',
          visible: this.isTowerCo(),
          minWidth: '105'
        },
        {
          name: 'years',
          title: 'Years',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '65'
        },
        {
          name: 'term',
          title: 'Term',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '65'
        },
        {
          name: 'nextPaymentDate',
          title: 'Date Due',
          callback: this.formatDate,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right',
          minWidth: '100'
        },
        {
          name: 'nextPayment',
          title: 'Due',
          callback: this.formatMoney,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right',
          minWidth: '80'
        },
        {
          name: 'paid',
          title: 'Paid',
          callback: this.formatMoney,
          titleClass: 'hidden-sm-and-down text-success',
          dataClass: 'hidden-sm-and-down text-success text-right',
          minWidth: '80'
        },
        {
          name: 'outstanding',
          title: 'O/S',
          callback: this.formatMoney,
          titleClass: 'hidden-xs-only text-warning',
          dataClass: 'hidden-xs-only text-warning text-right',
          minWidth: '75'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          titleClass: 'text-danger',
          dataClass: 'text-danger',
          callback: this.formatDate,
          minWidth: '95'
        }
      ]
    }
  }

}

</script>
